<template>
  <button class="base-button">
    <img src="@/assets/icons/DeleteDark.svg" alt="" class="icon-delete" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DeleteButton",
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/deleteButton";
</style>
